<template>
  <div>
    <full-view-spinner :show="inProgress" />
    <div v-show="!this.paymentToken">
      <div class="atu-box">
        <div class="box-headline">
          <h3 class="headline-small">
            {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.PAYMENT_OPERATION.HEADLINE") }}
          </h3>
        </div>
        <div class="atu-container">
          <div class="payment-operation">
            <div class="payment-operation__steps">
              <div class="payment-operation__step selected">
                <div class="payment-operation__step-number">
                  1
                </div>
                <div class="payment-operation__step-text">
                  {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.PAYMENT_OPERATION.1") }}
                </div>
              </div>
              <div class="payment-operation__step">
                <div class="payment-operation__step-number">
                  2
                </div>
                <div class="payment-operation__step-text">
                  {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.PAYMENT_OPERATION.2") }}
                </div>
              </div>
              <div class="payment-operation__step">
                <div class="payment-operation__step-number">
                  3
                </div>
                <div class="payment-operation__step-text">
                  {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.PAYMENT_OPERATION.3") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="atu-box">
        <div class="box-headline">
          <h3 class="headline-small">
            {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.ATU") }}
          </h3>
          {{ durationText }}
        </div>
        <div class="atu-container text--center">
          <h4 class="headline-secondary">
            {{ tariffSizeName }}
          </h4>
          <br>
          <div class="text-primary">
            {{ duration }}
          </div>
          <div
            class="atu-container__price"
            v-html="tariffPrice"
          />
        </div>
      </div>
      <div
        v-show="emailBlank"
        class="atu-box"
      >
        <div class="box-headline blue">
          <h3 class="headline-small">
            {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.EMAIL.HEADER") }}
          </h3>
        </div>
        <div class="atu-container">
          <validated-input-box
            id="emailField"
            ref="email"
            :validation-reg-exp="regex.EMAIL"
            :validation-error-message="
              this.$i18n.t('COMMON.ERROR_MESSAGES.EMAIL_ERROR')
            "
            :label="emailLabel"
            name="email"
          />
          <span class="icon-info__blue" />
          <strong>{{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.EMAIL.INFO") }}</strong>
          <p>
            {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.EMAIL.INFO_TEXT") }}
          </p>
        </div>
      </div>
      <div class="atu-box">
        <div class="box-headline blue">
          <h3 class="headline-small">
            {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.PAYMENT_OPTIONS.HEADLINE") }}
          </h3>
        </div>
        <div class="atu-container">
          <p class="text-primary text--center">
            {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.PAYMENT_OPTIONS.OPTIONS") }}
          </p>
          <div class="payment-option">
            <div class="payment-option__content">
              <div class="payment-option__entries">
                <span
                  class="payment-option__entry"
                  :class="{ selected: selected == 'mastercard' }"
                  @click="
                    () => {
                      selected = 'mastercard';
                    }
                  "
                >
                  <div
                    class="
                      payment-option__entry-image
                      payment-option__entry-image--mastercard
                    "
                  />
                  <div class="payment-option__entry-text">MasterCard</div>
                </span>
                <span
                  class="payment-option__entry"
                  :class="{ selected: selected == 'visa' }"
                  @click="
                    () => {
                      selected = 'visa';
                    }
                  "
                >
                  <div
                    class="
                      payment-option__entry-image
                      payment-option__entry-image--visa
                    "
                  />
                  <div class="payment-option__entry-text">VISA</div>
                </span>
                <span
                  class="payment-option__entry"
                  :class="{ selected: selected == 'sepa' }"
                  @click="
                    () => {
                      selected = 'sepa';
                    }
                  "
                >
                  <div
                    class="
                      payment-option__entry-image
                      payment-option__entry-image--sepa
                    "
                  />
                  <div class="payment-option__entry-text">
                    {{
                      this.$i18n.t(
                        "AUTO_TOPUP.ACTIVATE.PAYMENT_OPTIONS.BANK_TRANSFER"
                      )
                    }}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-wrapper">
        <button
          class="
            button button--blue button--submit button--icon
            icon-arrow-btn-right
          "
          @click="getIframe()"
        >
          {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.TO_PAYMENT") }}
        </button>
      </div>
      <accordion
        id="unzerAccordion"
        :label="this.$i18n.t('AUTO_TOPUP.ACTIVATE.INFO.1')"
      >
        {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.INFO.1_TEXT") }}
      </accordion>
      <accordion
        id="dataProtectionAccordion"
        :label="this.$i18n.t('AUTO_TOPUP.ACTIVATE.INFO.2')"
      >
        {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.INFO.2_TEXT") }}
      </accordion>
      <accordion
        id="dataChangeAccordion"
        :label="this.$i18n.t('AUTO_TOPUP.ACTIVATE.INFO.3')"
      >
        {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.INFO.3_TEXT") }}
      </accordion>
      <a class="autotopup-info-link">{{
        this.$i18n.t("AUTO_TOPUP.ACTIVATE.INFO.MORE_INFO")
      }}</a>
    </div>
    <div>
      <div id="iframe">
        <div v-if="this.paymentToken != ''">
          <div style="max-width: 500px; margin: auto">
            <strong
              style="cursor: pointer"
              @click="
                () => {
                  this.displayAccordion4 = !this.displayAccordion4;
                }
              "
            >
              <icon-info />{{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.INFO.4") }}
              <div v-show="displayAccordion4">
                <p>{{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.INFO.4_TEXT") }}</p>
              </div> </strong><br><br>
            <validated-input-box
              id="cardOwner"
              ref="cardOwner"
              :validation-reg-exp="regex.CARDHOLDER"
              :validation-error-message="
                this.$i18n.t('AUTO_TOPUP.ACTIVATE.CARD_OWNER_INVALID')
              "
              :label="this.$i18n.t('AUTO_TOPUP.ACTIVATE.CARD_OWNER')"
              name="cardOwner"
              :remove-whitespaces="false"
            />
          </div>
          <iframe
            :src="iframeUrl"
            class="iframe"
          />
          <p>{{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.LEGAL") }}</p>
          <div class="submit-wrapper">
            <button
              class="
                button button--blue button--submit button--icon
                icon-arrow-btn-right
              "
              :disabled="submitDisabled"
              @click="submitIframe"
            >
              {{ this.$i18n.t("AUTO_TOPUP.ACTIVATE.ACTIVATE") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Regex from "@/constants/regex.json";
const RESP_CODE_NOT_ALLOWED = 2;
const RESP_MSISDN_NOT_FOR_TOPUP = 5;

export default {
  name: "AutotopupActivate",
  props: {
    tariffSizeName: {
      type: String,
      required: true,
    },
    tariffPrice: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      default: "",
      required: false,
    },
    dataTariff: {
      type: Boolean,
      required: true,
    },
    emailBlank: {
      type: Boolean,
      required: true,
    },
    emailRequired: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      selected: "mastercard",
      paymentToken: "",
      iframeUrl: "",
      name: "",
      submitDisabled: false,
      inProgress: false,
      request: {},
      displayAccordion4: false,
    };
  },
  computed: {
    regex: function () {
      return Regex;
    },
    days: function () {
      if (this.duration.match(/\d+/g)) {
        return this.duration.match(/\d+/g)[0];
      } else return "30";
    },
    emailLabel: function () {
      if (this.emailRequired) {
        return this.$i18n.t("AUTO_TOPUP.ACTIVATE.EMAIL.LABEL") + " *";
      } else return this.$i18n.t("AUTO_TOPUP.ACTIVATE.EMAIL.LABEL");
    },
    durationText: function () {
      if (this.dataTariff) {
        return this.$i18n.t("AUTO_TOPUP.ACTIVATE.AFTER_CONSUMPTION", {
          days: this.days,
        });
      } else {
        return this.$i18n.t("AUTO_TOPUP.ACTIVATE.AFTER_DAYS", {
          days: this.days,
        });
      }
    },
  },
  watch: {
    cardOwner: function (newValue) {
      if (newValue != "" && this.request.cardNumber) {
        this.submitDisabled = false;
      }
    },
  },
  created: function () {
    window.addEventListener("message", this.processIframeChange);
  },
  unmounted: function () {
    window.removeEventListener("message", this.processIframeChange);
  },
  methods: {
    getIframe: function () {
      if (this.inProgress) {
        return;
      }
      if (this.emailBlank && this.emailRequired && !this.emailValid()) {
        this.$store.commit(
          "setErrorMessage",
          this.$i18n.t("COMMON.ERROR_MESSAGES.EMAIL_ERROR")
        );
        return;
      }
      this.inProgress = true;
      if (this.selected == "sepa") {
        this.saveEmail();
        this.$http
          .post("api/user/dreitvkarte/autoTopup", null)
          .then((response) => {
            this.processOkSepaResponse(response);
          })
          .catch((callData) => {
            this.processErrorResponse(callData);
          })
          .finally(() => {
            this.inProgress = false;
          });
        return;
      }
      var self = this;
      this.$http
        .post("api/user/paymentToken", {})
        .then(function (response) {
          self.paymentToken = response.data.token;
          self.iframeUrl = response.data.url;
          setTimeout(() => {
            const element = document.getElementById("iframe");
            element.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 200);
        })
        .catch(() => {
          self.$store.commit(
            "setErrorMessage",
            self.$i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE")
          );
        })
        .finally(() => {
          self.inProgress = false;
        });
    },
    processIframeChange: function (form) {
      if (!this.paymentToken) {
        return;
      }
      var data = JSON.parse(form.data);
      if (data.valid === "true") {
        let year = "20" + data.response.expiry.substring(0, 2);
        let month = data.response.expiry.substring(2, 4);
        this.request.cardNumber = data.response.identifier;
        this.request.cvcCode = data.response.cvc;
        this.request.cardType = data.response.brand;
        this.request.validToMonth = month;
        this.request.validToYear = year;
        if (this.$refs.cardOwner.getFieldValue() != "") {
          this.request.cardOwner = this.$refs.cardOwner.getFieldValue();
        }
        this.request.paymentToken = this.paymentToken;
      }
    },
    emailValid: function () {
      return this.$refs.email.isValidBeforeSubmit();
    },
    saveEmail: function () {
      if (!this.emailBlank || !this.emailValid()) return;
      var self = this;
      this.$http.post("api/user/emailChange", {
        email: self.$refs.email.getFieldValue(),
      });
    },
    formValid: function () {
      if (!this.request.cardNumber) return false;
      if (!this.$refs.cardOwner.isValidBeforeSubmit()) {
        return false;
      } else {
        this.request.cardOwner = this.$refs.cardOwner.getFieldValue();
      }
      if (this.emailBlank && this.emailRequired && !this.emailValid()) {
        this.paymentToken = undefined;
        this.$store.commit(
          "setErrorMessage",
          this.$i18n.t("COMMON.ERROR_MESSAGES.EMAIL_ERROR")
        );
        return false;
      }
      return true;
    },
    submitIframe: function () {
      if (!this.formValid() || this.inProgress) return;
      this.inProgress = true;
      this.saveEmail();
      this.$http
        .post("api/user/dreitvkarte/autoTopupCreditCard", this.request)
        .then((response) => {
          if (!response.data) this.processErrorResponse();
          const url = response.data.url;
          this.$store.commit("setLastTopupValue", this.tariffPrice);
          this.$gtm.trackEvent({
            category: "Meine Wertkarte",
            action: "AutoTopup activation",
            label: "Success, redirected away from Payment Card iframe",
            value: 0,
            noninteraction: false,
          });
          if (!url) {
            this.$router.push({ name: "atuSuccess" });
          } else {
            window.location = url;
          }
        })
        .catch((callData) => {
          this.processErrorResponse(callData);
        })
        .finally(() => {
          this.inProgress = false;
        });
      return;
    },
    processOkSepaResponse: function (response) {
      if (response && response.data && response.data.url) {
        window.location = response.data.url;
        this.$store.commit("setLastTopupValue", this.tariffPrice);
        this.$gtm.trackEvent({
          category: "Drei TV Streamingkarte",
          action: "AutoTopup",
          label: "Start Success",
          value: 0,
          noninteraction: false,
        });
      } else {
        this.$gtm.trackEvent({
          category: "Drei TV Streamingkarte",
          action: "AutoTopup start",
          label: "Start Error - no url",
          value: 0,
          noninteraction: false,
        });
        this.$store.commit(
          "setErrorMessage",
          this.$i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE")
        );
      }
    },
    processErrorResponse: function (callData) {
      if (callData && callData.response && callData.response.data) {
        let responseCode = callData.response.data.responseCode;

        if (responseCode == RESP_CODE_NOT_ALLOWED) {
          this.$gtm.trackEvent({
            category: "Drei TV Streamingkarte",
            action: "AutoTopup",
            label: "Start Error - not allowed",
            value: 0,
            noninteraction: false,
          });
          this.$store.commit(
            "setErrorMessage",
            this.$i18n.t("AUTO_TOPUP.ACTIVATE.ERROR.NOT_ALLOWED")
          );
          return;
        }
      }
      this.$store.commit(
        "setErrorMessage",
        this.$i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE")
      );
      this.$gtm.trackEvent({
        category: "Drei TV Streamingkarte",
        action: "AutoTopup start",
        label: "Start Error - technical issue",
        value: 0,
        noninteraction: false,
      });
    },
  },
};
</script>


<style lang="scss">
$breakpoint-sm: 576px;
$breakpoint-md: 768px;
$color-white: rgba(255, 255, 255, 1);
$color-black: rgba(0, 0, 0, 1);
$color-blue: rgba(0, 160, 210, 1);
$font-drei-script: "DreiScript-Bold", "Arial", sans-serif;
$font-helvetica-neue-bold: "Helvetica-Neue-Bold", "Helvetica", "Arial",
  sans-serif;

$component: "atu-box";

$color-grey: rgba(241, 241, 241, 1);
$color-darkgrey: rgba(92, 92, 92, 1);
$color-grey-off: rgba(221, 221, 221, 1);
$color-grey-border: rgba(215, 215, 215, 1);
$color-grey-background: rgba(230, 230, 230, 1);
$color-grey-checkbox: #999;

// Basic background colors
$bg-color-grey-main: rgba(241, 241, 241, 1);
$bg-color-grey-lighter: rgba(248, 248, 248, 1);
$bg-color-grey-darker: rgba(230, 230, 230, 1);

.#{$component} {
  box-shadow: 0 0 10px 0 #d7d7d7;
  margin-bottom: 30px;
  background-color: white;
  border-radius: 15px;
  overflow: hidden;

  .box-headline {
    //background-color: $color-grey;
    background-color: $color-grey-border;
    text-align: center;
    padding: 12px;
    h3 {
      margin: 0;
    }
  }
  .box-headline.blue {
    background-color: $color-blue;
    color: white;
  }
  .atu-container {
    padding: 30px 20px;

    .payment-operation {
      .container {
        @media (max-width: $breakpoint-sm) {
          padding: 0;
        }
      }

      .headline-secondary {
        @media (max-width: $breakpoint-sm) {
          font-size: 20px;
        }
      }

      &__steps {
        display: flex;
        flex-wrap: wrap;
        text-align: center;

        @media (min-width: $breakpoint-md) {
          flex-wrap: nowrap;
          flex-direction: row;
          justify-content: center;
        }
      }

      &__step {
        margin: 15px 0;
        flex: 1;
        display: flex;
        flex-basis: 100%;

        &:last-child {
          margin-bottom: 0;
        }

        @media (min-width: $breakpoint-md) {
          flex-direction: column;
          align-items: center;
        }

        &-text {
          margin-top: 2px;
          text-align: left;
          width: 100%;
          height: auto;

          @media (min-width: $breakpoint-md) {
            text-align: center;
          }
        }

        &-number {
          align-self: flex-start;
          min-width: 25px;
          margin-right: 15px;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background-color: $color-blue;
          font-family: $font-drei-script;
          color: $color-white;
          font-size: 20px;
          line-height: 24px;
          margin-top: 3px;

          @media (min-width: $breakpoint-md) {
            margin: 0 auto 15px auto;
            min-width: 50px;
            width: 70px;
            height: 70px;
            font-size: 35px;
            line-height: 65px;
          }
        }
      }
    }
    &__price {
      font-family: $font-helvetica-neue-bold;
      font-size: 35px;
      color: $color-blue;
    }
    .icon-info__blue::before {
      content: "\e055";
      color: #00779d;
      vertical-align: -20%;
      padding-right: 5px;
      font-size: 18px;
    }
    $component: "payment-option";
    $breakpoint-iphone5: 330px;

    .#{$component} {
      .container {
        @media (max-width: $breakpoint-sm) {
          padding: 0;
        }
      }

      .headline-secondary {
        @media (max-width: $breakpoint-sm) {
          font-size: 20px;
        }
      }

      &__content {
        background-color: $color-white;
        text-align: center;
        padding: 0 20px 20px 20px;

        @media (min-width: $breakpoint-sm) {
          padding: 0 30px 30px 30px;
        }
      }

      &__entries {
        display: flex;
        justify-content: center;
      }

      &__entry {
        margin: 5px 5px 25px 5px;
        cursor: pointer;
        padding: 5px;
        background-color: rgba(241, 241, 241, 1);
        color: #999;
        min-width: 33.33%;
        font-size: 12px;
        text-decoration: none;
        position: relative;

        @media (min-width: $breakpoint-sm) {
          min-width: 0;
          width: 100px;
        }

        @media (max-width: $breakpoint-iphone5) {
          font-size: 8px;
        }

        &::before {
          border-radius: 50%;
          background-color: white;
          border: 1px solid #999;
          content: "";
          height: 24px;
          width: 24px;
          position: absolute;
          bottom: -44px;
          left: calc(50% - 12px);
        }

        &-image {
          margin: 10px;
          width: auto;
          height: 25px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;

          &--mastercard {
            background-image: url("asset/icon-mastercard.svg");
          }

          &--visa {
            background-image: url("asset/icon-visa.svg");
          }

          &--sepa {
            background-image: url("asset/icon-sepa.svg");
          }
        }
      }
      &__entry.selected::after {
        background-color: #0f273b;
        border-radius: 50%;
        content: "";
        height: 14px;
        width: 14px;
        position: absolute;
        bottom: -39px;
        left: calc(50% - 7px);
      }
    }
  }
}
.submit-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 15px;
  .button--submit {
    width: 100%;
    max-width: 300px;
    display: flex;
    justify-content: center;
  }
}
.autotopup-info-link {
  color: black;
  font-size: 18px;
}

.iframe {
  width: 100%;
  height: 200px;
  border: none;
  @media (max-width: 396px) {
    height: 280px;
  }
}
</style>

